<template>
  <ActivateConfig />
</template>

<script setup lang="ts">
import ActivateConfig from './ActivateConfig.vue';
</script>
